import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
var baseUri = "WebApi.asmx/api/topicService";
const store = {};
const mutations = {
    GET_DEEP_LINK() {

    },
    CREATE_TOPIC() {

    },
    DELETE_TOPIC() {

    },
    SET_TOPIC_OWNER() {

    },
    SET_TOPIC_AMBASSADOR() {

    },
    RESET_TOPIC_AMBASSADOR() {

    },
    GET_TOPIC_ACCESS(state, posts) {
        state.topicAccess = posts.access;
    },
    GET_TOPICTYPE_ACCESS(state, posts) {
        state.topicTypeAccess = posts.access;
    },
    GET_TOPICS_BY_TYPE_AND_STGID(state, posts) {
        state.topicsByTypeAndStgIdList = posts.list;
    },
    GET_APP_DATA(state, posts) {
        state.topicDetail = posts.list;
    },
    GET_MFG_DATA(state, posts) {
        state.mfgDetail = posts.list;
    },
    SET_LIST(state, posts) {
        var cols = posts.cols;
        if (cols.length === 0) {
            //cols.push({ caption: 'ID', width: 150, dataType: 'string', dataField: 'TopicId' });
            cols.push({ caption: 'Title', dataType: 'string', dataField: 'Title' });
            cols.push({ caption: 'Beschreibung', dataType: 'string', dataField: 'TpcDescription' });
            cols.push({ caption: 'Suchfelder', dataType: 'string', cellTemplate: 'sfTemplate', dataField: 'BmwSuchfelder' });
            cols.push({ caption: 'Thementyp', dataType: 'string', dataField: 'TtyName' });
            cols.push({ caption: 'Erstellt von', dataType: 'string', dataField: 'CreatedBy', visible: false });
            cols.push({ caption: 'Erstellt am', dataType: 'date', dataField: 'CreatedOn', visible: false });
            cols.push({ caption: 'Geändert von', dataType: 'string', dataField: 'ChangedBy', visible: false });
            cols.push({ caption: 'Geändert am', dataType: 'date', dataField: 'ChangedOn', visible: false });
        }
        cols = cols.filter(m => {
            switch (m.dataField) {
                case "TopicId":
                case "Title":
                case "TpcDescription":
                case "BmwSuchfelder":
                case "TtyName":
                    return false;
                default:
                    return true;
            }
        });
        //cols.splice(0, 0, { caption: 'ID', width: 100, dataType: "number", dataField: 'TopicId' });
        //cols.splice(0, 0, { caption: '', width: 20, cellTemplate: 'actionTemplate', ataType: "number", dataField: '$id' });
        //cols.push({ caption: 'Status', width: 100, dataType: 'string', dataField: 'StatusName' });
        //cols.push({ caption: 'Assignee', width: 150, dataType: 'string', dataField: 'Assignee' });
        //cols.push({ caption: 'Owner', width: 150, dataType: 'string', dataField: 'Scout' });
        var list = posts.list;
        list.filter(m => { return m.BmwSuchfelder }).forEach(m => { m.BmwSuchfelder = '<ul>' + m.BmwSuchfelder.split(',').map(s => { return '<li>' + s + '</li>'; }).join('') });
        state.topicList = list;
        state.columnList = cols;
        state.currentUsrId = posts.currentUsrId;
        state.topicListIsLoading = false;
        state.access = posts.access;
    },
};
const state = {
    topicListIsLoading: false,
    topicList: [],
    mfgDetail:[],
    topicDetail:[],
    columnList: [],
    topicsByTypeAndStgIdList: [],
    currentUsrId: 0,
    currentFilter: null,
    access: {
        allowCart: true,
        allowNewCart: true,
        allowChangeCart: true,
        allowChangeState: true,
        allowChangeTopicLink: true,
        allowCreateEx: true,
        allowCreate: true,
        allowRead: true,
        allowUpdate: true,
        allowBulkDownload: true,
        allowBulkExport: true,
        allowListLayout: true,
        allowCommenting: true,
    },
    topicAccess: {
        Open: false,
        Update: false,
        New: false,
        Delete: false,
        InlineEdit: false,
        Visible: false,
        ChangeStatus: false,
    },
    topicTypeAccess: {
        Open: false,
        Update: false,
        New: false,
        Delete: false,
        InlineEdit: false,
        Visible: false,
        ChangeStatus: false,
    },
};
const getters = {};
const actions = {
    getTopicList({ commit }, filter) {
        window.LoadPanel.Show();
        state.topicListIsLoading = true;
        state.currentFilter = filter;
        return axios
            .get(baseUri + '/GetGenericSimpleList', { params: { filter: JSON.stringify(filter) } })
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('SET_LIST', res.data);
                    return true;
                }
                else {
                    alert(res.data.errorMessage);
                    return res;
                }
               
            });
    },
    getTopicAccess({ commit }, { args, topicId }) {
        return axios
            .get(baseUri + '/GetTopicAccess', { params: { args, topicId } })
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('GET_TOPIC_ACCESS', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return res.data;
                }
            });
    },
    getDeepLink({ commit  }, { topicId }) {
        return axios
            .get(baseUri + '/GetDeepLink', { params: { topicId } })
            .then(res => { 
                if (res.data.success == true) {
                    commit('GET_DEEP_LINK', res.data); 
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },

    getApplicantData({ commit },  topicId) {
        return axios
            .get(baseUri + '/GetApplicantData?topicId=' + topicId)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('GET_APP_DATA', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return res.data;
                }
            });
    },

    getMfgData({ commit },  topicId) {
        return axios
            .get(baseUri + '/GetMfgData?topicId=' + topicId)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('GET_MFG_DATA', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return res.data;
                }
            });
    },
    getApplicantDataList({ commit }, topicIdList) {
        return axios
            .get(baseUri + '/GetApplicantData?topicIdList=' + JSON.stringify(topicIdList))
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('GET_APP_DATA', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return res.data;
                }
            });
    },
    getTopicTypeAccess({ commit }, { ttyId }) {
        return axios
            .get(baseUri + '/GetTopicTypeAccess', { params: { ttyId } })
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('GET_TOPICTYPE_ACCESS', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return res.data;
                }
            });
    },
    createTopic({ commit }, { ttyId, usrId }) {
        return axios
            .get(baseUri + '/CreateTopic', { params: { ttyId, usrId } })
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('CREATE_TOPIC', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage, "Create Record");
                    return res.data;
                }
            });
    },
    deleteTopic({ commit }, { topicId, args }) {
        return axios
            .get(baseUri + '/DeleteTopic', { params: { topicId, args } })
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('DELETE_TOPIC', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage, "Delete Record");
                    return res.data;
                }
            });
    },
    setTopicOwner({ commit }, { usrId, args }) {
        return axios
            .get(baseUri + '/SetTopicOwner', { params: { usrId, args } })
            .then(res => { 
                if (res.data.success == true) {
                    commit('SET_TOPIC_OWNER', res.data);
                }
                return res;
            });
    },
    setTopicAmbassador({ commit }, { usrId, args }) {
        return axios
            .get(baseUri + '/SetTopicAmbassador', { params: { usrId, args } })
            .then(res => { 
                if (res.data.success == true) {
                    commit('SET_TOPIC_AMBASSADOR', res.data);
                }
                return res;
            });
    },
    resetTopicAmbassador({ commit }, { usrId, args }) {
        return axios
            .get(baseUri + '/ResetTopicAmbassador', { params: { usrId, args } })
            .then(res => {
                if (res.data.success == true) {
                    commit('RESET_TOPIC_AMBASSADOR', res.data);
                }
                return res;
            });
    },
    bulkChangeStatus({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", args);
        axios
            .post(baseUri + '/ChangeStatus', formData)
            .then(res => {
                if (res.data.Success == true) {
                    console.log(commit);
                    state.topicListIsLoading = true;
                    axios
                        .get(baseUri + '/GetGenericSimpleList', { params: { filter: JSON.stringify(state.currentFilter) } })
                        .then(res => {
                            if (res.data.success == true) {
                                window.LoadPanel.Hide();
                                commit('SET_LIST', res.data);
                            }
                            else {
                                window.LoadPanel.Hide();
                                alert(res.data.errorMessage);
                            }
                        });
                }
                else {
                    window.LoadPanel.Hide();
                    alert(res.data.Error);
                }
            });
    },
    getTopicsByTypeAndStgId({ commit }, { ttyId, stgId, onlyPublishedInFilter }) {
        state.myCartsAndPublicListIsLoading = true;
        const onlyPublished = onlyPublishedInFilter == true;
        return axios
            .get(baseUri + '/GetTopicsByTypeAndStgId', { params: { ttyId, stgId, onlyPublished } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICS_BY_TYPE_AND_STGID', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}